// https://vuex.vuejs.org/en/actions.html
import { API } from 'aws-amplify'
import { ErrorMessageHelper } from '../../../errorMessageHelper'

export default {
  listAllTarifs (context) {
    context.commit('listTarifsState', 'in-progress')
    context.commit('updateCountIncrement')
    return API.get('worktools', '/tarifs-horaires', {}).then(response => {
      context.commit('listTarifsState', 'ok')
      context.commit('updateCountIncrement')
      context.commit('listTarifsRecords', response)
    }).catch(error => {
      ErrorMessageHelper(context, 'Impossible de lister les tarifs hotaire.')
      context.commit('listTarifsState', 'error')
      context.commit('updateCountIncrement')
      return Promise.reject(error)
    })
  },
  addCategorie (context, params) {
    context.commit('addCategorieState', 'in-progress')
    context.commit('updateCountIncrement')
    return API.post('worktools', '/tarifs-horaires/categories', {
      body: {
        libelle: params.libelle,
        code: params.code
      }
    }).then(response => {
      context.commit('addCategorieState', 'ok')
      context.commit('updateCountIncrement')
      context.dispatch('listAllTarifs')
    }).catch(error => {
      ErrorMessageHelper(context, 'Impossible d\'ajouter la catégorie de tarif horaire.')
      context.commit('addCategorieState', 'error')
      context.commit('updateCountIncrement')
      return Promise.reject(error)
    })
  },
  editCategorie (context, params) {
    context.commit('addCategorieState', 'in-progress')
    context.commit('updateCountIncrement')
    return API.put('worktools', '/tarifs-horaires/categories/' + params.categorieId, {
      body: {
        libelle: params.libelle,
        code: params.code
      }
    }).then(response => {
      context.commit('addCategorieState', 'ok')
      context.commit('updateCountIncrement')
      context.dispatch('listAllTarifs')
    }).catch(error => {
      ErrorMessageHelper(context, 'Impossible de modifier la catégorie de tarif horaire.')
      context.commit('addCategorieState', 'error')
      context.commit('updateCountIncrement')
      return Promise.reject(error)
    })
  },
  setTarif (context, params) {
    context.commit('setTarifState', { state: 'in-progress', clientId: params.clientId, categorieId: params.categorieId })
    context.commit('updateCountIncrement')
    return API.put('worktools', '/tarifs-horaires/categories/' + params.categorieId + '/clients/' + params.clientId, {
      body: {
        clientId: params.clientId,
        categorieId: params.categorieId,
        tarif: params.tarif
      }
    }).then(response => {
      context.commit('setTarifState', { state: 'ok', clientId: params.clientId, categorieId: params.categorieId })
      context.commit('updateCountIncrement')
    }).catch(error => {
      ErrorMessageHelper(context, 'Impossible de mettre à jour le tarif.')
      context.commit('setTarifState', { state: 'error', clientId: params.clientId, categorieId: params.categorieId })
      context.commit('updateCountIncrement')
      return Promise.reject(error)
    })
  }
}
